import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import * as actions from './actions';
import * as brokeragesApi from './api';

export function* fetchBrokerages(action) {
    try {
        const brokerages = yield call(brokeragesApi.fetchAll);
        yield put(actions.fetchBrokeragesSuccess(brokerages));
    } catch (e) {
        yield put(actions.fetchBrokeragesFailure(e));
    }
}

export function* watchForFetchBrokerages() {
    yield takeEvery(actions.FETCH_BROKERAGES, fetchBrokerages);
}

export default function* root() {
    yield all([fork(watchForFetchBrokerages)]);
}
